import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  devicePixelRatio,
  ckeInlineConfig,
  DefaultLanguageId,
} from "src/app/shared/constants";
import { PlaybookCommunicationService } from "../../shared/services/playbook-communication.service";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import {
  moveItemInArray,
  CdkDropListGroup,
  CdkDropList,
  CdkDrag,
} from "@angular/cdk/drag-drop";
import {
  ContentBlock,
  TabsBlockElement,
  Container,
} from "src/app/shared/model/container.models";
import { ActivatedRoute } from "@angular/router";
import { cloneDeep, each, forEach, isNull } from "lodash";
import { Location } from "@angular/common";
import { LocalStorageService } from "src/app/shared/services/local-storage/local-storage.service";
import { SendIframeUrlService } from "src/app/shared/services/send-iframe-url/send-iframe-url.service";

@Component({
    selector: "app-tab",
    templateUrl: "./tab.component.html",
    styleUrls: ["./tab.component.scss"],
    standalone: false
})
export class TabComponent implements OnInit, AfterViewInit {
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;

  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  @Input("contentBlock") contentBlock: ContentBlock;
  @Input() container: Container;
  @Input() parentSectionId: number;
  @Input() level: number;
  @Input() pageTemplateId: number;
  @Input() reorderContent: boolean;
  @Input() hideContent: boolean;
  @Input() playbookId: number;
  @Output() tabChange: EventEmitter<any> = new EventEmitter();
  currentEditTab;
  devicePixelRatio = devicePixelRatio;
  sortEnabled = false;
  config;
  languageId: number;
  defaultLanguageId = DefaultLanguageId;
  vBuilderRedirectURl: string;
  constructor(
    private commService: PlaybookCommunicationService,
    private commonHttpService: CommonHttpService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private localStorageService: LocalStorageService,
    private sendIframeUrlService: SendIframeUrlService
  ) {
    this.target = null;
    this.source = null;
    this.config = ckeInlineConfig;
  }

  ngOnInit() {
    this.languageId =
      +this.activatedRoute.snapshot.queryParams.languageId ||
      this.defaultLanguageId;
    this.vBuilderRedirectURl =
      this.activatedRoute.snapshot.queryParams.r || null;
    this.contentBlock.tabsBlock.elements =
      this.contentBlock.tabsBlock.elements.filter((element) => {
        return !element.isDeleted;
      });

    this.contentBlock.tabsBlock.elements.sort((a, b) => {
      return a.orderBy - b.orderBy;
    });

    this.commService
      .getActivateTab()
      .subscribe((tabElementData: TabsBlockElement) => {
        if (tabElementData.tabsBlockId === this.contentBlock.tabsBlock.id) {
          this.activateTabElement(tabElementData, false);
          this.changeRoutingState(tabElementData);
        }
      });
    const tabId =
      +window.location.pathname.split("/tab/")[1] ||
      +this.localStorageService.getLocalStogareByKey("tabId");
    if (tabId) {
      const currentTab = this.contentBlock.tabsBlock.elements.filter(
        (tab) => tab.id === tabId
      )[0];
      this.activateTabElement(
        currentTab || this.contentBlock.tabsBlock.elements[0],
        false,
        tabId
      );
    } else if (this.contentBlock.tabsBlock.elements.length) {
      this.activateTabElement(
        this.contentBlock.tabsBlock.elements[0],
        false,
        tabId
      );
    }
  }

  ngAfterViewInit() {
    const phElement = this.placeholder.element.nativeElement;
    phElement.style.display = "none";
    phElement.parentNode.removeChild(phElement);
  }

  /**
   * @param tElement a tab element from list of tabs
   * To check if selected tab container is on or not
   */
  tabIsActive(tElement: TabsBlockElement) {
    return tElement
      ? tElement.isActive ||
          (tElement.isActive == null && tElement.orderBy === 0)
      : false;
  }

  /**
   * To set the tab image asset
   */
  getTabImage(tabElement) {
    return tabElement.assetId
      ? `/api/Assets/Image/${tabElement.assetId}?height=60&ratio=${this.devicePixelRatio}`
      : ``;
  }

  /**
   * To activate selected tab and set element to view in container
   */
  activateTabElement(tElement: TabsBlockElement, isClicked, tabId?) {
    if (tElement) {
      this.currentEditTab = tElement.id;
      this.contentBlock.tabsBlock.elements.map((block) => {
        block.isActive = false;
      });
      tElement.isActive = true;
      this.commService.setCurrentTabData(tElement);
      if (isClicked) {
        this.tabChange.emit(this.parentSectionId);
      }
      if (tabId && isClicked) {
        this.changeRoutingState(tElement);
      }
    }
  }

  changeRoutingState(tab) {
    this.location.go(
      `/playbookeditor/${this.playbookId}/page/${this.container.id}/section/${
        this.parentSectionId
      }/tab/${tab.id}?languageId=${this.languageId}${
        this.vBuilderRedirectURl ? "&r=" + this.vBuilderRedirectURl : ""
      }`
    );
    this.sendIframeUrlService.sendUrlToParent(this.location.path());
    this.localStorageService.setLocalStogareByKey("tabId", tab.id);
  }

  /**
   * Method to add new tab element in list
   */
  addTabElement() {
    let order = 0;
    each(this.contentBlock.tabsBlock.elements, (el) => {
      order = order + 1;
      el.isActive = false;
    });
    const reqObj = {
      playbookId: this.contentBlock.playbookId,
      tabsBlockId: this.contentBlock.tabsBlock.id,
      isDraftModeOn: false,
      order,
      pageTemplateId: this.pageTemplateId,
    };
    this.commService.setServerProcess(true);
    this.commonHttpService
      .postWithHeaders(
        {
          uri: "/api/TabsBlockElements/AddTabElement",
          object: reqObj,
        },
        {
          pageId: this.container.id,
          sectionId: this.parentSectionId,
          playbookId: this.contentBlock.playbookId,
          languageId: this.languageId,
          isdraftmode: this.container.isCurrentPageInDraftMode,
        }
      )
      .subscribe(
        (res: TabsBlockElement) => {
          res.isActive = true;
          this.contentBlock.tabsBlock.elements.push(res);
          this.commService.setServerProcess(false);
          this.changeRoutingState(res);
        },
        (error) => this.commService.setServerProcess(false)
      );
  }

  /**
   * Method to update tab element title
   * @param event Ckeditor emmited event
   * @param tElement TabElement to be updated
   */
  updateTabElement(event, tElement: TabsBlockElement) {
    $(`#tab-menu-${tElement.id}`).hide();
    const updatedValue = event.editor.getData().trim();
    if (
      isNull(tElement.title) ||
      tElement.title.localeCompare(updatedValue) !== 0
    ) {
      const reqObj = {
        id: tElement.id,
        playbookId: this.contentBlock.playbookId,
        isDraftModeOn: false,
        order: tElement.orderBy,
        languageId: this.languageId,
        title: updatedValue,
        assetId: tElement.assetId,
        pageTemplateId: this.pageTemplateId,
      };
      this.commService.setServerProcess(true);

      this.commService.setUpdatingTab(true);
      this.commonHttpService
        .putWithHeaders(
          {
            uri: "/api/TabsBlockElements/UpdateTabElement",
            object: reqObj,
          },
          {
            pageId: this.container.id,
            sectionId: this.parentSectionId,
            playbookId: this.contentBlock.playbookId,
            languageId: this.languageId,
            isdraftmode: this.container.isCurrentPageInDraftMode,
          }
        )
        .subscribe(
          (res: TabsBlockElement) => {
            tElement.title = updatedValue;
            event.editor.setData(updatedValue);
            this.commService.setServerProcess(false);
            this.commService.setUpdatingTab(false);
            console.log("Done with /api/TabsBlockElements/UpdateTabElement");
          },
          (error) => this.commService.setServerProcess(false)
        );
    } else {
      event.editor.setData(updatedValue);
    }
  }

  toggleSorting() {
    this.sortEnabled = !this.sortEnabled;
  }

  // To open custom nav on click of edit icon
  openEditor(tElement, editor) {
    const menu = $(`#tab-menu-${tElement.id}`);
    menu.css({
      width: $(`#tab-${tElement.id}`).closest("article.content").width() + "px",
    });
    $(`#tab-menu-${tElement.id}`).show();
    editor.click();
  }

  drop() {
    if (!this.target) {
      return;
    }
    const phElement = this.placeholder.element.nativeElement;
    const parent = phElement.parentNode;

    phElement.style.display = "none";

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(
      this.source.element.nativeElement,
      parent.children[this.sourceIndex]
    );

    this.target = null;
    this.source = null;
    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(
        this.contentBlock.tabsBlock.elements,
        this.sourceIndex,
        this.targetIndex
      );
      const orderObj = this.contentBlock.tabsBlock.elements.map(
        (element, index) => {
          return Object.assign({}, { id: element.id, order: index });
        }
      );
      const reqObj = {
        playbookId: this.contentBlock.playbookId,
        orders: orderObj,
        pageTemplateId: this.pageTemplateId,
      };
      let tabsBlock = cloneDeep(this.contentBlock.tabsBlock);
      forEach(this.contentBlock.tabsBlock.elements, (cont, index) => {
        cont.orderBy = index;
      });
      this.commService.setServerProcess(true);
      this.commonHttpService
        .putWithHeaders(
          {
            uri: "/api/TabsBlockElements/ReorderTabs",
            object: reqObj,
          },
          {
            pageId: this.container.id,
            sectionId: this.parentSectionId,
            playbookId: this.contentBlock.playbookId,
            languageId: this.languageId,
            isdraftmode: this.container.isCurrentPageInDraftMode,
          }
        )
        .subscribe(
          (res) => {
            tabsBlock = null;
            this.commService.setServerProcess(false);
          },
          (error) => {
            this.commService.setServerProcess(false);
            this.contentBlock.tabsBlock = tabsBlock;
            tabsBlock = null;
          }
        );
    }
  }
  enter = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop === this.placeholder) {
      return true;
    }
    const phElement = this.placeholder.element.nativeElement;
    const dropElement = drop.element.nativeElement;

    const dragIndex = __indexOf(
      dropElement.parentNode.children,
      drag.dropContainer.element.nativeElement
    );
    const dropIndex = __indexOf(dropElement.parentNode.children, dropElement);
    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      const sourceElement = this.source.element.nativeElement;
      phElement.style.width = sourceElement.clientWidth + "px";
      phElement.style.height = sourceElement.clientHeight + "px";

      sourceElement.parentNode.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = "";
    if (dropIndex === 0) {
      dropElement.parentNode.insertBefore(phElement, dropElement);
    } else {
      dropElement.parentNode.insertBefore(
        phElement,
        dragIndex < dropIndex ? dropElement.nextSibling : dropElement
      );
    }
    (this.source as any).start();

    (this.placeholder as any).enter(
      drag,
      drag.element.nativeElement.offsetLeft,
      drag.element.nativeElement.offsetTop
    );
    return false;
  };
  //#endregion
}
function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}
